export const JWT_TOKEN_LOCAL_STORAGE = 'JWT_TOKEN'
export const REFRESH_TOKEN_LOCAL_STORAGE = 'REFRESH_TOKEN'
export const AUTHED_INFOR_LOCAL_STORAGE = 'AUTHED_INFOR'
